/* OREN custom cursor — dot + ring + contextual label (v2 — rAF-throttled) */
(function(){
  if(window.matchMedia('(pointer: coarse)').matches) return;
  if(window.matchMedia('(hover: none)').matches) return;

  const dot = document.createElement('div');
  dot.id = 'oren-cursor-dot';
  const ring = document.createElement('div');
  ring.id = 'oren-cursor-ring';
  const label = document.createElement('div');
  label.id = 'oren-cursor-label';
  document.body.appendChild(dot);
  document.body.appendChild(ring);
  document.body.appendChild(label);
  document.documentElement.classList.add('has-custom-cursor');

  let mouseX = 0, mouseY = 0;
  let ringX = 0, ringY = 0;
  let dotX = 0, dotY = 0;
  let labelX = 0, labelY = 0;
  let pending = false;

  function onMouseMove(e){
    mouseX = e.clientX;
    mouseY = e.clientY;
    if(!pending){
      pending = true;
      requestAnimationFrame(render);
    }
  }

  function render(){
    pending = false;
    // Dot snaps to mouse (still smooth via transform on a positioned element)
    dotX = mouseX;
    dotY = mouseY;
    dot.style.transform = 'translate3d(' + (dotX-3) + 'px,' + (dotY-3) + 'px,0)';
    labelX = mouseX + 22;
    labelY = mouseY + 18;
    label.style.transform = 'translate3d(' + labelX + 'px,' + labelY + 'px,0)';
  }

  function ringAnimate(){
    ringX += (mouseX - ringX) * 0.16;
    ringY += (mouseY - ringY) * 0.16;
    ring.style.transform = 'translate3d(' + (ringX-18) + 'px,' + (ringY-18) + 'px,0)';
    requestAnimationFrame(ringAnimate);
  }
  ringAnimate();

  document.addEventListener('mousemove', onMouseMove, { passive: true });

  function resolveLabel(target){
    const explicit = target.closest('[data-cursor]');
    if(explicit) return explicit.getAttribute('data-cursor');
    if(target.closest('.fragment')) return 'View Fragment';
    if(target.closest('.journal-card, a[href*="/blogs/"]')) return 'Read';
    if(target.closest('.product-gallery img, .hero-immersive img, .fragment-img img')) return 'Zoom';
    if(target.closest('button[name="add"], .btn-light-primary, .btn-primary')) return 'Add';
    if(target.closest('.btn-light-secondary, .btn-secondary')) return 'Read';
    if(target.closest('.newsletter-form button, form[action*="contact"] button')) return 'Subscribe';
    if(target.closest('.product-form label, [data-option-label]')) return 'Select';
    if(target.closest('a.cart, a[href*="/cart"]')) return 'Cart';
    if(target.closest('.nav-logo, .footer-logo')) return 'Home';
    if(target.closest('.nav-right a, .footer a')) return 'Open';
    if(target.closest('a[href*="/collections/"]')) return 'View Delivery';
    if(target.closest('a[href*="/pages/"]')) return 'Open';
    if(target.closest('a[href]')) return 'Open';
    if(target.closest('button')) return 'Click';
    if(target.closest('input[type="text"], input[type="email"], textarea')) return 'Type';
    return '';
  }

  function isDark(target){
    let el = target;
    while(el && el !== document.body){
      if(el.matches && (el.matches('section.navy') || el.matches('.ticker') || el.matches('.footer') || el.matches('.hero-immersive'))){
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  const hoverSelector = 'a, button, [role="button"], input, select, textarea, label, .fragment, .nav-logo, .footer-logo, [data-cursor-hover], [data-cursor]';
  document.addEventListener('mouseover', function(e){
    if(e.target.closest(hoverSelector)){
      ring.classList.add('is-hover');
      dot.classList.add('is-hover');
      const text = resolveLabel(e.target);
      if(text){
        label.textContent = text;
        label.classList.add('visible');
      }
      if(isDark(e.target)){
        ring.classList.add('on-dark');
        dot.classList.add('on-dark');
        label.classList.add('on-dark');
      }else{
        ring.classList.remove('on-dark');
        dot.classList.remove('on-dark');
        label.classList.remove('on-dark');
      }
    }
  }, { passive: true });
  document.addEventListener('mouseout', function(e){
    if(e.target.closest(hoverSelector)){
      ring.classList.remove('is-hover');
      dot.classList.remove('is-hover');
      label.classList.remove('visible');
    }
  }, { passive: true });

  document.addEventListener('mouseleave', function(){
    dot.style.opacity = '0';
    ring.style.opacity = '0';
    label.classList.remove('visible');
  });
  document.addEventListener('mouseenter', function(){
    dot.style.opacity = '1';
    ring.style.opacity = '1';
  });
})();

/* Lit reveal */
(function(){
  if(!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('lit'); io.unobserve(en.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.hero-statement, .hero-meta, .hero-immersive-caption').forEach(function(el){
    io.observe(el);
  });
})();
